import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FaceCool"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M11.9999 18C14.1057 17.9964 16.0555 16.8891 17.1374 15.0825L15.8549 14.3325C15.0408 15.6844 13.578 16.5111 11.9999 16.5111C10.4218 16.5111 8.959 15.6844 8.1449 14.3325L6.8624 15.0825C7.94427 16.8891 9.89408 17.9964 11.9999 18ZM12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 9.21523 21.3938 6.54451 19.4246 4.57538C17.4555 2.60625 14.7848 1.5 12 1.5ZM11.9999 3C15.5139 3.00548 18.7033 5.0556 20.1674 8.25H18.7499C18.7499 7.83579 18.4141 7.5 17.9999 7.5H5.99991C5.5857 7.5 5.24991 7.83579 5.24991 8.25H3.83241C5.29656 5.0556 8.48596 3.00548 11.9999 3ZM3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C20.9965 11.2403 20.8957 10.4841 20.7 9.75H18.75V11.25C18.75 12.0784 18.0784 12.75 17.25 12.75H14.79C14.0493 12.7601 13.4122 12.2281 13.29 11.4975L12.8775 9H11.1225L10.7325 11.4975C10.6103 12.2281 9.97317 12.7601 9.2325 12.75H6.75C5.92157 12.75 5.25 12.0784 5.25 11.25V9.75H3.3C3.10432 10.4841 3.0035 11.2403 3 12Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FaceCool.vue"]]);
